<div class="w-full md:w-[290px] h-[200px] md:h-[200px] flex-shrink-0 rounded-2xl border border-white p-4 bg-[#2E507C] text-white relative scrollbar-hide">
  <div class="border-b border-[#ECA136] pb-2 mb-2">
    <h3 class="font-bold text-base">{{ nombre }}</h3>
  </div>
  <p class="paragraph-small py-1"><span class="headline-01">Teléfono:</span> {{ telefono }}</p>
  <p class="paragraph-small py-1"><span class="headline-01">Calle:</span> {{ calle }}</p>
  <p class="paragraph-small py-1"><span class="headline-01">N. Int:</span> {{ numeroInterior }}</p>
  <p class="paragraph-small py-1"><span class="headline-01">Referencias:</span> {{ referencias }}</p>
  <p class="paragraph-small py-1"><span class="headline-01">CP:</span> {{ cp }}</p>
  <div class="absolute bottom-4 right-4">
    <button>
      <img src="assets/logos/Arrow-Circle-Right.svg" class="w-8 h-8" />
    </button>
  </div>
</div>
